import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const unLinkSurfaceNodesMutation = gql`
  mutation unLinkSurfaceNodes($input: UnLinkSurfaceNodesInput!) {
    unLinkSurfaceNodes(input: $input) {
      data {
        fromNodeId
        toNodeId
      }
      error
      success
    }
  }
`;

export default mutation(unLinkSurfaceNodesMutation);
